import { BaseModel } from "@blue-chip/core";
import Project from "./Project";
import RemitAddress from "./RemitAddress";

export default class ProjectRemitAddress extends BaseModel {
  static get belongsTo() {
    return [Project, RemitAddress];
  }
}
